import VueRouter from 'vue-router';

import PredefinedView from '../components/PredefinedView.vue';
import DetailView from '../components/DetailView.vue';
import LoginView from '../components/Login/LoginView.vue';
import OrderView from '../components/OrderView.vue';

import store from '../store/store';
import oidc from '../auth/oidc';

const router = new VueRouter({
  routes: [
    {
      path: '/',
      component: PredefinedView,
      name: 'home',
    },
    {
      path: '/details/:type/:id',
      component: DetailView,
      name: 'details',
    },
    {
      path: '/order/:id',
      component: OrderView,
      name: 'order',
    },
    {
      path: '/login',
      component: LoginView,
      name: 'login',
    },
  ],
});

router.beforeEach((to, from, next) => {
  // Offline-Prüfung des Authentik-Access-Tokens (Signatur-Vertrauen liegt beim Gateway).
  const valid = oidc.isAuthenticated();
  if (valid) {
    store.dispatch('updateToken');
    const ud = oidc.getUserData();
    if (ud) store.dispatch('updateUserData', ud);
  } else {
    oidc.clearTokens(); // nur lokal löschen — KEIN Redirect (sonst Loop)
    store.dispatch('updateToken');
  }

  if (!valid && to.name !== 'login') next({ name: 'login' });
  else if (valid && to.name === 'login') next({ name: 'home' });
  else next();
});

export default router;
